// @flow
import React from 'react';
import AlertCircle from 'react-feather/dist/icons/alert-circle';

import { Paragraph } from 'components/Typography';
import { splitTextOnUrls } from 'helpers';

type NotificationPropsType = {|
  errorMessage: string,
  style: Object,
|};

// Messages from the API can carry a url the user has to follow, such as the
// Next Gen membership link in a missing-membership error. Rendering the text as
// a single node would leave that url as unclickable plain text.
const renderText = (text) => {
  if (typeof text !== 'string') {
    return text;
  }

  const parts = splitTextOnUrls(text);

  if (parts.length < 2) {
    return text;
  }

  return parts.map((part) =>
    part.type === 'url' ? (
      <a
        key={part.start}
        href={part.value}
        target="_blank"
        rel="noopener noreferrer"
        className="notification-link"
      >
        {part.label || part.value}
      </a>
    ) : (
      part.value
    ),
  );
};

const Notification = (props: NotificationPropsType) => {
  const { errorMessage, style } = props;
  return !!errorMessage && errorMessage !== '' ? (
    <div style={style} className="notification-container">
      <div className="notification-icon column">
        <AlertCircle />
      </div>
      <div className="notification-content notification-column">
        <div className="notification-errorMessage">
          <Paragraph style={{ color: 'white' }}>
            {renderText(errorMessage)}
          </Paragraph>
        </div>
      </div>
    </div>
  ) : null;
};

Notification.defaultProps = {
  errorMessage: '',
  style: {},
};

export default Notification;
